import { type ImageInterface } from 'Image/types';
import { modifyHref } from 'NavigationHelpers';

export const regionAwareImageUrlForFormat = (image: ImageInterface, format: string) =>
    image?.formats?.[format] && modifyHref(image.formats[format].url);

export default regionAwareImageUrlForFormat;
